import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Gashandlewarning from '../entities/gashandlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface GashandlewarningState extends ListState<Gashandlewarning>{
    editHandlewarnings:Gashandlewarning
    anlyseHandlewarning:Gashandlewarning
    seeHandlewarnings:Gashandlewarning
}
class GashandlewarningModule extends ListModule<GashandlewarningState,any,Gashandlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Gashandlewarning>(),
        loading:false        
    }
    actions={
        async getPage(context:ActionContext<GashandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/GasHandleWarning/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Gashandlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async getPagedLast(context: ActionContext<GashandlewarningState, any>, payload: any) {

            // context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/GasHandleWarning/GetPagedLast', { params: payload.data });
            // context.state.loading = false;
            let page = reponse.data.result as PageResult<Gashandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items;
            return page.items;
        },
        async create(context:ActionContext<GashandlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/GasHandleWarning/CreateOrUpdate',payload.data);
        },
        async uploadimg(context:ActionContext<GashandlewarningState,any>,payload:any){
            //console.log(payload.data.UploadData);
            await Ajax.post('/api/services/app/UploadFile/UploadFile',{params:payload.data.UploadData});
        },
        async update(context:ActionContext<GashandlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/GasHandleWarning/Update',payload.data);
        },
        async delete(context:ActionContext<GashandlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/GasHandleWarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<GashandlewarningState,any>,payload:any){
            let reponse=await Ajax.get('​/api​/services​/app​/ThHandleWarning​/GetById?Id='+payload.id);
            return reponse.data.result as Gashandlewarning;
        },
        async getPageByDate(context: ActionContext<GashandlewarningState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/GasHandleWarning/GetPageByDate', { params: payload.data });
            let page = reponse.data.result as PageResult<Gashandlewarning>;
            //context.state.totalCount = page.totalCount;
            //context.state.list = page.items; 6aba6214f15918e1bc4225e3ea66df430b9fbce7
            return page.items;
        },
    };
    mutations={
        setCurrentPage(state:GashandlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:GashandlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        analyse(state: GashandlewarningState, handlewarning:Gashandlewarning) {
            state.anlyseHandlewarning = handlewarning;
        },
        edit(state:GashandlewarningState,handlewarning:Gashandlewarning){
            
            state.editHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        },
        see(state:GashandlewarningState,handlewarning:Gashandlewarning){
            
            state.seeHandlewarnings=handlewarning;
            //console.log(state.editFloor);
        }
    }
}
const gashandlewarningModule=new GashandlewarningModule();
export default gashandlewarningModule;